import base from "../../baseurl";
import token from "../../getTk";

const Create = async () => {
  //console.log(state)
  const tokenA = token.get();
  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });
  const Update = await api
    .post("bus-stops/showall-s", {
      timeout: false,
      json: {},
    })
    .json();
  return Update;
};

export default Create;
